import Box from '@mui/material/Box'
import TablePagination from '@mui/material/TablePagination'
import FullHeightFlexContainer from 'components/ui/FullHeightFlexContainer'
import { DocListItem } from 'entities/Documents'

import DocumentsTable from './DocumentsTable'
import PaginationActions from './PaginationActions'

function LabelDisplayedRows({ from, to, count }: { from: number; to: number; count: number }) {
  const totalText = count !== -1 ? count : to
  const text = `${totalText}件のうち${from}～${to}件までを表示`

  return (
    <Box component="span" display="flex" alignItems="center">
      {text}
    </Box>
  )
}

type Props = {
  rows: DocListItem[]
  page: number
  totalCount: number
  selectedIds: string[]
  rowsPerPage: number
  setSelectedIds: (ids: string[]) => void
  onPageChange: React.ComponentProps<typeof TablePagination>['onPageChange']
  onRowsPerPageChange: React.ComponentProps<typeof TablePagination>['onRowsPerPageChange']
  openRenameDialog?: (oID: string, name: string) => void
}

const PaginatedTable = (props: Props) => {
  const {
    rows,
    page,
    totalCount,
    selectedIds,
    setSelectedIds,
    rowsPerPage,
    onPageChange,
    onRowsPerPageChange,
    openRenameDialog,
  } = props

  return (
    <FullHeightFlexContainer>
      <DocumentsTable
        rows={rows}
        selectedIds={selectedIds}
        setSelectedIds={setSelectedIds}
        openRenameDialog={openRenameDialog}
      />
      <Box flexShrink="0">
        <TablePagination
          component="div"
          sx={{ mb: 1 }}
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
          labelRowsPerPage="最大表示件数:"
          labelDisplayedRows={LabelDisplayedRows}
          ActionsComponent={PaginationActions}
          rowsPerPageOptions={[10, 25, 50, 100, 500]}
          data-testid="table-pagination"
        />
      </Box>
    </FullHeightFlexContainer>
  )
}

export default PaginatedTable
